<template>
	<div class="contanier">
		<div v-show="payStatus == 0" class="app">
			<div class="tip">
				<p>
					<img src="https://youwola.com:9000/webgoods/dui.png" alt="" />
					订单提交成功！还差一步就可以抢到心爱的宝贝啦,快快支付吧~
				</p>
				<p>
					请于<span>{{ showTime }}</span>内完成支付
				</p>
				<p>
					待支付<span style="margin-left: 10px">{{ total }}元</span>
				</p>
			</div>
			<div class="paybg">
				<img src="https://youwola.com:9000/webgoods/微信支付.png" alt="" />微信支付
			</div>
			<div class="paymain" style="background-color: white">
				<p style="
            line-height: 30px;
            text-align: center;
            margin-top: 40px;
            margin-bottom: 40px;
            color: #666;
          ">
					请在<span style="color: #ff6700">{{ showTime }}</span>内完成支付，点击<el-link type="primary"
						@click="flash">刷新</el-link>
				</p>
				<div style="
            height: 220px;
            margin-bottom: 50px;
            width: 220px;
            border: 1px dashed #333;
          ">
					<img :src="qrCodeDataUrl" alt="QR Code" />
				</div>
				<div class="codetip" style="margin-top: 30px; width: 260px">
					<img style="width: 50px; height: 50px" src="https://youwola.com:9000/扫码.png" alt="" />
					<p style="color: #666; text-justify: left; font-size: 15px">
						请使用微信扫一扫，扫描二维码支付
					</p>
				</div>
				<p style="font-size: 40px; text-align: center; color: #ff6700">
					￥{{ total }}
				</p>
			</div>
		</div>
		<div v-show="payStatus == 2" style="padding-top: 30px">
			<div class="center"
				style="width: 1300px;padding:30px; height: 400px; background-color: white; margin: 0 auto;">
				<div class="center" style="
            height: 200px;
            width: 100%;
            border-top: 1px solid #99999936;
            border-bottom: 1px solid #99999936;
            border-right: 1px solid #99999936;
            border-left: 4px solid #ff6700;
            
          ">
					<div>
						<p class="center" style="text-align: center; color: #666; margin-bottom: 20px;"> <img
								src="https://youwola.com:9000/webgoods//警告.png" alt="">&nbsp; 订单已全部取消！</p>
						<div>
							<el-link type="primary"
								@click="toOder(2)">查看订单</el-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<el-link type="primary" @click="$router.push('/')">回首页看看</el-link>
						</div>
					</div>

				</div>
			</div>
		</div>

		<div v-show="payStatus == 1">
			<div class="cart py-container">
				<!--主内容-->
				<div class="paysuccess">
					<div class="success">
						<h3>
							<img src="https://youwola.com:9000/webgoods/dui.png" width="48" height="48" />　恭喜您，支付成功啦！
						</h3>
						<div style="width: 500px; margin: 0 auto">
							<div class="paydetail">
								<p>交易方式：微信支付</p>
								<p>
									交易金额：<span style="color: #ff6700">{{ total }}元</span>
								</p>
							</div>
							<div class="button">
								<el-link type="primary"
									@click="toOder(1)">查看订单</el-link>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
								<el-link type="primary" @click="$router.push('/')">继续购物</el-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import QRious from "qrious";
	export default {
		name: "Pay",
		data() {
			return {
				countDown: 0, // 倒计时的总时间（单位：秒）
				countDownInterval: null, // 倒计时定时器
				showTime: "",
				qrCodeDataUrl: "",
				total: 0,
				code: "",
				timestamp: "",
				payStatus: 0,
				orderId: "",
			};
		},
		activated() {
			this.payStatus = 0;
			this.getPayInfo();
			this.startCountDown();
		},
		deactivated() {
			this.stopCountDown();
			this.countDownInterval = null;
		},

		methods: {
			toOder(type) {
				this.$router.push({
					name: "Order",
					params: {
						type: type,
					},
				});
			},
			flash() {
				location.reload();
			},
			generateQRCode() {
				const qr = new QRious({
					value: this.code, // 这里可以替换成你需要的值
					size: 220,
					level: "H",
				});
				this.qrCodeDataUrl = qr.toDataURL();
			},
			getPayInfo() {
				this.orderId = this.$route.params.orderId;
				if (!this.orderId) {
					this.orderId = localStorage.getItem("orderId");
				}
				this.$axios
					.post("/api/pay/getPayInfo", {
						orderId: this.orderId,
					})
					.then((res) => {
						if (res.data.code == 200) {
							this.total = res.data.total;
							this.code = res.data.codeUrl;
							this.timestamp = res.data.timestamp;
							this.countDown = this.getRemainingValidTime(this.timestamp);
							this.generateQRCode();
						} else {
							this.notifyError(res.data.msg);
						}
					})
					.catch((err) => {
						return Promise.reject(err);
					});
			},
			getRemainingValidTime(timestamp) {
				// 转换为秒
				const seconds = Math.floor(timestamp / 1000);
				// 当前时间
				const now = Math.floor(new Date().getTime() / 1000);
				// 有效时间（以秒为单位）
				const validTime = 600; // 半小时
				// 计算剩余时间
				const remainingTime = Math.max(0, validTime - (now - seconds));
				return remainingTime;
			},
			startCountDown() {
				this.countDownInterval = setInterval(() => {
					this.countDown--; // 倒计时时间递减
					this.showTime = this.convertSecondsToTimeFormat(this.countDown);
					this.$axios
						.post("/api/pay/getPayStatus", {
							orderId: localStorage.getItem("orderId"),
						})
						.then((res) => {
							if (res.data.code == "200") {
								this.payStatus = res.data.status;

								if (this.payStatus != 0) {
									clearInterval(this.countDownInterval);
								}
							} else {
								console.log(res.data.msg);
							}
						})
						.catch((err) => {
							return Promise.reject(err);
						});
					if (this.countDown <= 0) {
						this.payStatus = 2;
						this.stopCountDown(); // 倒计时结束，停止定时器
						this.countDown = 0; // 将倒计时时间重置为0
					}
				}, 1000); // 每隔1秒更新一次时间

				this.$once("hook:beforeDestroy", function() {
					clearInterval(this.countDownInterval);
					this.countDownInterval = null;
				});
			},
			stopCountDown() {
				clearInterval(this.countDownInterval); // 停止定时器
			},
			convertSecondsToTimeFormat(seconds) {
				var minutes = Math.floor(seconds / 60);
				var remainingSeconds = seconds % 60;
				var result =
					minutes.toString().padStart(2, "0") +
					"分" +
					remainingSeconds.toString().padStart(2, "0") +
					"秒";
				return result;
			},
		},
	};
</script>

<style scoped>
	.button {
		margin-left: 120px;
	}

	.center {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.codetip {
		margin-bottom: 20px;
		border: 1px solid #ff6700;
		padding-left: 15px;
		padding-top: 20px;
		padding-bottom: 20px;
		display: flex;
	}

	.tip {
		color: #666;
		padding: 10px 15px;
		line-height: 32px;
		background: white;
	}

	.tip p:last-child {
		float: right;
		position: relative;
		top: -25px;
	}

	.paybg {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		/* 垂直居中 */
		justify-content: center;
		/* 文字和图片在一条水平线上 */
		font-size: 32px;
		color: #b0b0b0;
		margin-bottom: 20px;
	}

	.tip p:first-child {
		display: flex;
	}

	.tip p:first-child img {
		margin-right: 8px;
	}

	.paybg img {
		width: 60px;
		height: 50px;
		margin-right: 10px;
	}

	.paymain {
		height: 600px;
		border-top: 3px solid #ff6700;
	}

	.app {
		padding-top: 20px;
		margin-left: 198px;
		margin-right: 198px;
	}

	span {
		color: #ff6700;
	}

	.contanier {
		background-color: #f9fafa;
		position: relative;
		top: -20px;
		height: 900px;
	}

	.paymain p,
	.paymain div {
		width: 50%;
		/* 元素宽度 */
		margin-left: auto;
		/* 左边距自动 */
		margin-right: auto;
		/* 右边距自动*/
	}

	h3 {
		display: flex;
		align-items: center;
		/* 垂直居中 */
		justify-content: center;
		/* 文字和图片在一条水平线上 */
	}

	a {
		color: #666;
	}

	.col666 {
		color: #999;
	}

	.fontSize {
		font-size: 18px;
		color: #ff3041;
	}

	.top {
		background-color: #f1f1f1;
	}

	.paysuccess {
		padding: 25px;
		margin: 20px 0;
		font-family: "微软雅黑";
	}

	.paysuccess .success {
		padding-top: 30px;
		padding-bottom: 30px;
		background-color: white;
		width: 900px;
		padding-left: 200px;
		padding-right: 200px;
		margin: 0 auto;
	}

	.success h3 {
		margin: 20px 0;
		font-weight: 700;
		font-size: 20px;
	}

	.success .paydetail {
		position: relative;
	}

	.paydetail p {
		line-height: 26px;
		margin-left: 120px;
		font-size: 18px;
		line-height: 40px;
	}

	p.button {
		margin: 30px 0;
	}

	.paydetail .sui-btn.btn-xlarge {
		font-size: 18px;
		background-color: #ff4301;
		border: 1px solid #ff4301;
	}

	.paydetail .sui-btn.btn-goshop {
		background-color: #eee;
		border: 1px solid #e1e1e1;
	}

	.submit {
		text-align: center;
	}

	.submit .btn-submit {
		width: 220px;
		height: 48px;
		line-height: 48px;
		margin-right: 10px;
		padding: 0;
		font-family: "Microsoft YaHei";
		font-size: 18px;
	}

	.recharge {
		padding-left: 100px;
		padding-right: 100px;
	}

	.rechargeCon {
		width: 500px;
		margin: 0 auto;
	}

	.rechargeCon h3 {
		padding: 0 0 15px;
	}

	.rechargeCon p {
		padding: 5px 0;
		font-size: 14px;
	}

	.rechargeCon .textR {
		display: block;
		margin-left: 110px;
	}

	.rechargeCon .textR .Info {
		border: 1px solid #ccc;
		display: inline-block;
		width: 60px;
		line-height: 24px;
		text-align: center;
		margin-bottom: 15px;
		margin-right: 8px;
		cursor: pointer;
	}

	.rechargeCon .textR .Info.on {
		border: 1px solid #ff4301;
		position: relative;
	}

	.rechargeCon .textR .Info.on em {
		width: 14px;
		height: 15px;
		position: absolute;
		bottom: 0px;
		right: 0px;
	}

	.inputInfo {
		height: 24px;
		line-height: 24px;
		border: 1px solid #ccc;
		width: 200px;
	}

	.cart {
		height: 550px;
	}
</style>